import { render, staticRenderFns } from "./SpaceChannels.vue?vue&type=template&id=bf65d1ac"
import script from "./SpaceChannels.vue?vue&type=script&lang=js"
export * from "./SpaceChannels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports